import styled from 'styled-components';
import { spaceFlowContainer } from 'src/utilities/UIStyles/variables/spacing';

import { blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const PersonalInformationContainer = styled.section`
  background-color: rgb(245, 245, 245);
  padding-bottom: 2.5%;

  .card-container {
    ${spaceFlowContainer}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: unset;

    p {
      margin-bottom: 1rem;
    }

    form {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    form > * {
      margin-bottom: 1rem;
    }
  }
`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  background-color: ${whiteSphera};
  padding: 3% 0 2.5% 10%;
  ${spaceFlowContainer(true)}

  > figure {
    width: 85px;
    height: 85px;
    margin-right: 5%;

    > img {
      width: 100%;
      height: auto;
    }
  }

  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    width: 80%;
    margin-right: 10%;
  }

  > p {
    color: ${blackSphera};
    font-size: 1.5vw;
    width: 45%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
    }

    > p {
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    padding: 25% 0 2.5% 0%;

    > figure {
      margin-right: 0;
      margin-bottom: 5%;

      > img {
      }
    }

    > h2 {
      font-size: 6vw;
      width: 100%;
      margin-right: 0;
      margin-bottom: 2%;
      text-align: center;
    }

    > p {
      text-align: center;
      font-size: 4vw;
      width: 90%;
      margin-bottom: 5%;
    }
  }
`;
